import React, { useState, useEffect } from 'react';
import { useLocation, Link, Navigate } from 'react-router-dom';
import './Home.css'

import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import LoginModal from '../../components/loginSection/LoginModal';
import HeroSection from './components/HeroSection'
import FeaturesSection from './components/FeaturesSection'
import { useUser } from '../../UserContext';

const Home = () => {
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [message, setMessage] = useState('');
    const location = useLocation();
    const { initialized, isAuthenticated } = useUser();

    useEffect(() => {
        if (location.state && location.state.message) {
            setMessage(location.state.message);
            window.history.replaceState({}, document.title);
        }
    }, [location]);

    if (initialized && isAuthenticated) {
        return <Navigate to="/dashboard/home" replace />;
    }

    const openLoginModal = () => setIsLoginModalOpen(true);
    const closeLoginModal = () => setIsLoginModalOpen(false);

    return (
        <div className="home-page">
            <Header
                openLoginModal={openLoginModal}
                isAuthenticated={initialized ? isAuthenticated : null}
            />
            {message && (
                <div className="alert-banner">
                    <div className="alert-content">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                            <polyline points="22 4 12 14.01 9 11.01"/>
                        </svg>
                        {message}
                    </div>
                </div>
            )}
            <main>
                <HeroSection />
                <FeaturesSection />
                {initialized && isAuthenticated && (
                    <div className="go-to-dashboard">
                        <Link to="/dashboard" className="dashboard-button">
                            Go to Dashboard
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14M12 5l7 7-7 7"/>
                            </svg>
                        </Link>
                    </div>
                )}
            </main>
            <Footer />
            <LoginModal isOpen={isLoginModalOpen} onClose={closeLoginModal} />
        </div>
    );
};

export default Home;
